import { Redirect } from "react-router-dom";
// import { BulkMobileValidation } from "../pages/BulkMobileValidation";
import Main from "../pages/Main";
// import { MobileValidation } from "../pages/MobileValidation";
import SMSCost from "../pages/SMSCost";

const Routes = [
  {
    path: "/sms-cost-calculator",
    component: SMSCost,
    name: "SMS Cost Calculator",
  },
  // { path: '/mobile-validation', component: MobileValidation, name: 'Mobile Validation' },
  // { path: '/bulk-mobile-validation', component: BulkMobileValidation, name: 'Bulk Mobile Validation' },
  { path: "/healthcheck", component: Main, name: "Health Check" },
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/sms-cost-calculator" />,
  },
  // Catch-all: redirect any unknown path to default
  {
    component: () => <Redirect to="/sms-cost-calculator" />,
  },
];

export default Routes;
